<template>
  <div>
    <iban :iban="payment" :notShowBin="true" />
  </div>
</template>

<script>
import Iban from '../Iban.vue';

export default {
  components: { Iban },
  props: ['payment'],
};
</script>
